export default __webpack_public_path__ + "static/media/vittasLogo.18683de5.svg";